module.exports = __webpack_public_path__ + "static/img/1.b2a8747.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/1.png
// module id = RsF5
// module chunks = 0